<template>
  <div>
    <Alerts/>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-col sm="6">
        <b-form-group id="exampleInputGroup2">
          <b-form-input
            id="exampleInput2"
            type="text"
            size="sm"
            v-model="form.name"
            required
            placeholder="Contact name"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="exampleInputGroup3">
          <b-form-input
            id="exampleInput3"
            type="text"
            size="sm"
            v-model="form.subject"
            required
            placeholder="Subject line"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="exampleInputGroup4">
          <textarea
            class="form-control form-control-sm"
            v-model="form.message"
            id="exampleInput3"
            required
            placeholder="Type your message"
            rows="6"
          ></textarea>
        </b-form-group>
        <div class="text-right">
          <b-btn class="btn-light-blue-outline mr-2" type="reset" variant="danger" size="sm">Clear All Fields</b-btn>
          <b-btn class="btn-blue" type="submit" variant="primary" size="sm">Submit</b-btn>
        </div>
      </b-col>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
.btn {
  width: 100px;
}
</style>

<script>
import Alerts from "./Alerts";
export default {
  components: {
    Alerts
  },
  data() {
    return {
      form: {
        name: "",
        subject: "",
        message: ""
      },
      show: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      axios
        .post("contact", { data: this.form })
        .then(response => {
          this.$emit("alert", {
            message: "Email has been sent successfully!",
            type: "success"
          });

          // just clear the field
          this.form = { name: "", subject: "", message: "" }
          window.scrollTo(0, 0);
        })
        .catch(error => {
          this.$emit("alert", {
            message: JSON.parse(error.response.data),
            type: "danger"
          });
          console.log(error.response.data);
          window.scrollTo(0, 0);
        });
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form = { name: "", subject: "", message: "" }
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<!-- b-form-1.vue -->


// WEBPACK FOOTER //
// resources/assets/js/components/ContactForm.vue